module.exports = __webpack_public_path__ + "media/images/countryrect/qa-13959c004615117602959350d7f7478d.svg";